

module.exports = (rgb) => `rgb(${rgb.red}, ${rgb.green}, ${rgb.blue})`;



// WEBPACK FOOTER //
// ./src/utilities/color/factories/functions/rgb/toCss.js